import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RosterPreviousIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                d="m16.55 1.165.1.076L24.538 8l-7.886 6.76a1 1 0 0 1-1.392-1.432l.09-.087L20.296 9H16C10.477 9 6 13.477 6 19s4.477 10 10 10 10-4.477 10-10a1 1 0 0 1 2 0c0 6.627-5.373 12-12 12S4 25.627 4 19C4 12.475 9.209 7.166 15.695 7.004L16 7h4.296l-4.947-4.24a1 1 0 0 1-.184-1.31l.076-.1a1 1 0 0 1 1.31-.185z"
            />
        </svg>
    );
};
